import React, { MutableRefObject, useMemo } from 'react';
import { MMMIcon } from '../../icons';
import { isInChristmasRange } from '../../utils';

interface MoneyExplosionProps {
    containerRef: MutableRefObject<HTMLDivElement | null>;
}

const MoneyExplosion = ({ containerRef }: MoneyExplosionProps) => {
    const Logo = useMemo(() => {
        if (isInChristmasRange(new Date())) return <MMMIcon className="fill-current !text-color8 transition-all size-[50px]" />
        return <MMMIcon className="fill-current !text-color8 transition-all size-[50px]" />;
    }, [])

    let cleanupTimeout: any = null;

    const explodeMoney = () => {
        // Reproducir sonido
        const sound = new Audio('/sounds/money-sound.mp3');
        sound.play().catch((e) => {
            console.warn('No se pudo reproducir el sonido:', e);
        });

        const container = containerRef.current;
        if (!container) return;

        const originX = 60;
        const originY = 40;
        const totalBills = 240;
        const duration = 6000;

        for (let i = 0; i < totalBills; i++) {
            const bill = document.createElement('div');
            bill.className = 'bill';

            const size = 50 + Math.random() * 90;
            bill.style.setProperty('--bill-size', size + 'px');
            bill.style.left = originX + 'px';
            bill.style.top = originY + 'px';

            container?.appendChild(bill);

            const dx = (Math.random() - 0.3) * window.innerWidth;
            const dy = (Math.random() - 0.5) * window.innerHeight * 0.7;
            const rot = Math.random() * 720 - 360;
            const gravity = 0.2 + Math.random();

            let x = originX;
            let y = originY;
            let vx = dx / 60;
            let vy = dy / 60;
            let angle = 0;

            const fall = setInterval(() => {
                vy += gravity * 0.1;
                x += vx;
                y += vy;
                angle += rot / 60;

                bill.style.transform = `translate(${x}px, ${y}px) rotate(${angle}deg) scale(1)`;

                if (y > window.innerHeight + 200) {
                    clearInterval(fall);
                    bill.remove();
                }
            }, 14);
        }

        if (cleanupTimeout) clearTimeout(cleanupTimeout);
        cleanupTimeout = setTimeout(() => {
            if (container) {
                container.innerHTML = "";
            }
        }, duration);
    };

    return (
        <>
            <button
                onClick={explodeMoney}
                className="bg-color7"
            >
                {Logo}
            </button>
        </>
    );
};

export default MoneyExplosion;
